/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useRef, useEffect, useContext } from 'react';
import moment from 'moment';
import { Button, Input, InputGroup, InputGroupAddon, Badge, Collapse } from 'reactstrap';
// import Picker, { SKIN_TONE_MEDIUM_LIGHT } from 'emoji-picker-react';
import { EmojiButton } from '@joeattardi/emoji-button';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import DemoService from '../../../services/DemoService';

// local imports
import UserNotApproved from './UserNotApproved';
import notificationSound from '../../../assets/notification.mp3';
import './ProviderChat.css';
import send from "../../../assets/send.png";
import note from "../../../assets/note.png";
import { clients, clientSubscriptionPlans, clientSubscriptions, messages as dbMessages } from '../demoData';

// variables
let copyMessages = [];
let currentSearchResult = null;
let currentSearchPage = 0;
let searchResult = [];
let pageSize = 30;

const ProviderChat = props => {

    // variables
    let timeout = 0;
    let audio = new Audio(notificationSound);
    let counter = 0;
    let doubleClickCounter = 0;

    // constants

    // contexts
    const { colors } = useContext(ThemeContext);
    const { user, setUser, userApprovalStatus } = useContext(AuthContext);

    // states
    const [connectionLoading, setConnectionLoading] = useState(true);
    const [statusString, setStatusString] = useState("");
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [newNote, setNewNote] = useState({ messageId: '', content: '' });
    const [conversationNotes, setConversationNotes] = useState([
        {
            content: 'This is a sample note1'
        },
        {
            content: 'This is a sample note2m which a longer note than the note1 shown above'
        }
    ]);
    const [showChatScrollDown, setShowChatScrollDown] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState({ status: false, identity: "" });
    const [message, setMessage] = useState("");
    const [showNewMessageLine, setShowNewMessageLine] = useState(false);
    const [search, setSearch] = useState({ status: false, value: "" });
    const [toggleTopMenu, setToggleTopMenu] = useState(false);
    const [toggleLeftMenu, setToggleLeftMenu] = useState(true);
    const [toggleRightMenu, setToggleRightMenu] = useState(false);
    const [toggleProfileMenu, setToggleProfileMenu] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Chat with your clients from here!</h2>,
                placement: 'center',
                target: '#providerChatDiv',
            }
        ]
    });
    let helpers = null;

    useEffect(() => {
        document.getElementById("root").classList.value = "";
        document.getElementById("root").firstElementChild.firstElementChild.classList.value = "firstChildDiv";
        document.getElementById("root").firstElementChild.classList.value = "firstChildDiv";
        window.addEventListener('resize', getHeights);

        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles.includes("DemoProvider")) {
                    setUser(data.user);
                    setMessages(dbMessages);
                    copyMessages = dbMessages;
                    if (!data.user.demoTakenFor.includes("ProviderChat")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                    setConnectionLoading(false);
                    getHeights();
                } else {
                    // props.history.replace('PagePath');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })
        // getUser();
        // getSubscriptionDetails();
        // getNotifications();
        // toggleSidebar();
        return () => {
            // console.log("leaving", selectedConversation, ",,,", statusString);
            leaveConversation();
            window.removeEventListener('resize', getHeights);
            document.getElementById("root").classList.value = "container container-fluid";
            document.getElementById("root").firstElementChild.firstElementChild.classList.value = "";
            document.getElementById("root").firstElementChild.classList.value = "";
        };
    }, [])

    useEffect(() => {
        if (
            (toggleLeftMenu && toggleRightMenu) ||
            (toggleLeftMenu && toggleProfileMenu)
        ) {
            document.getElementById("mainContainer").classList = "col-md-6 col-12";
        } else {
            document.getElementById("mainContainer").classList = "col-md-9 col-12";
        }
        if (toggleLeftMenu) {
            document.getElementById("asideLeftContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            if (!document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.add("d-none");
            }
        } else {
            document.getElementById("asideLeftContainer").classList =
                "col-md-3 d-md-block col-12 d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
        if (toggleRightMenu) {
            document.getElementById("asideRightContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            document.getElementById("mainContainer").classList =
                "col-md-6 d-md-block col-12 d-none";
        } else {
            document.getElementById("asideRightContainer").classList = " d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
        if (toggleProfileMenu) {
            document.getElementById("asideProfileContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            document.getElementById("mainContainer").classList =
                "col-md-6 d-md-block col-12 d-none";
        } else {
            document.getElementById("asideProfileContainer").classList = "d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
    }, [toggleLeftMenu, toggleRightMenu, toggleProfileMenu]);

    useEffect(() => {
        if (!showNewMessageLine)
            scrollToBottom();
        if (currentSearchResult) {
            // console.log("addMessage");
            // setTimeout(() => {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            for (let i = 0; i < 10; i++) {
                element.parentElement.scrollIntoView();
            }
            // }, 50);
        }
    }, [messages.length])

    useEffect(() => {
        if (!showNewMessageLine && isTyping.identity === "client")
            getHeights();
    }, [isTyping.status])

    useEffect(() => {
        if (search.status) {
            document.getElementById("searchInput").focus();
        }
    }, [search.status]);

    useEffect(() => {
        removeMark();
        if (search.value) {
            currentSearchPage = 0;
            searchResult = [];
            performSearch();
        }
    }, [search.value]);

    const loadEmojiKeyborad = () => {
        const picker = new EmojiButton();
        const trigger = document.querySelector('.trigger');
        picker.on('emoji', selection => {
            // `selection` object has an `emoji` property
            // containing the selected emoji
            onEmojiClick(null, selection);
        });
        trigger.addEventListener('click', () => picker.togglePicker(trigger));
    }

    const closeRightMenus = () => {
        document.getElementById("asideRightContainer").classList = "d-none";
        document.getElementById("asideProfileContainer").classList = "d-none";
        setToggleRightMenu(false);
        setToggleProfileMenu(false);
    };

    const toggle = () => setIsOpen(!isOpen);

    const getHeights = () => {
        try {
            const mainHeight = document.getElementById("mainContainer").offsetHeight;
            const headerHeight = document.getElementById("header").offsetHeight;
            const typingDivHeight = document.getElementById("typingDiv") ? document.getElementById("typingDiv").offsetHeight : 0;
            const footerHeight = document.getElementById("footer").offsetHeight;
            const chatDivHeight = mainHeight - headerHeight - typingDivHeight - footerHeight;
            document.getElementById('chatDiv').setAttribute("style", `height: ${chatDivHeight}px`);
            document.getElementById('chatDiv').style.height = `${chatDivHeight}px`;
            scrollToBottom();
        } catch (err) { }
    }

    const handleChatScroll = (e) => {
        let chatList = e.target;
        const value = chatList.scrollHeight - chatList.scrollTop - chatList.clientHeight;
        if (!showNewMessageLine && value > 200) {
            setShowNewMessageLine(true)
        } else if (showNewMessageLine && value < 200) {
            setShowNewMessageLine(false)
        }
        if (!showChatScrollDown && value > 500) {
            setShowChatScrollDown(true)
        } else if (showChatScrollDown && value < 500) {
            setShowChatScrollDown(false)
        }
    }

    function scrollToBottom() {
        try {
            let someElement = document.getElementById('chat');
            someElement.scrollTop = someElement.scrollHeight + document.getElementById('chat').lastChild.offsetHeight;
        } catch (err) { }
    }

    const onEmojiClick = (emojiObject) => {
        setMessage(message => message + emojiObject.emoji);
    }

    const leaveConversation = () => {
        setStatusString("");
        setSelectedConversation(null);
        searchResult = [];
        setIsTyping({ status: false, identity: "" });
        setMessage("");
        setMessages([]);
        copyMessages = [];
    }

    const addMessage = (item) => {
        if (item.author !== "provider") {
            audio.play();
        }
        setMessages(messages => [...messages, item]);
        copyMessages.push(item);
    }

    const handleTyping = (e) => {
        if (e.keyCode === 13) {
            document.getElementById('sendButton').click();
        }
    }

    const sendMessage = () => {
        if (message !== '') {
            // selectedConversation.sendMessage(message);
            setIsTyping({ status: true, identity: 'client' });
            addMessage({ author: 'provider', body: message });
            setMessage('');
            setTimeout(() => {
                addMessage({ author: 'client', body: "Hello, This is a demo message" });
                setIsTyping({ status: false, identity: 'client' });
            }, [1000]);
        }
    }

    const handleMessageDoubleClick = (e) => {
        doubleClickCounter += 1;
        if (doubleClickCounter == 1) {
            const tempTarget = e.target;
            setTimeout(() => {
                if (doubleClickCounter == 1) {
                    // console.log("single_click_callback");
                } else {
                    if (!toggleRightMenu) {
                        setToggleRightMenu(true);
                    }
                    setNewNote({ messageId: tempTarget.id, content: tempTarget.innerText });
                }
                doubleClickCounter = 0;
            }, 300);
        }
    }

    const addNote = () => {
        setConversationNotes([...conversationNotes, { content: newNote.content }]);
        setNewNote({ messageId: "", content: "" });
    }

    // search functions
    const handleSearch = (value) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            setSearch({ ...search, value: value });
        }, 500);
    }

    const performSearch = async () => {
        let tempArray = [];
        let start = copyMessages.length - 1 - (pageSize * currentSearchPage);
        let end = 0;
        for (let i = start; i >= end; i--) {
            let position = copyMessages[i].body.toLowerCase().search(search.value.toLowerCase());
            if (position > -1)
                tempArray.push({ start: position, index: i });
        }
        searchResult.push(tempArray);
        if (searchResult.length !== 0) {
            currentSearchPage = searchResult.length - 1;
        }
        currentSearchResult = searchResult[currentSearchPage][0];
        await addMark();
    }

    const searchUpDown = async (direction) => {
        if (searchResult.length > 0) {
            let arrayIndex = await searchResult[currentSearchPage].findIndex(item => item.index === currentSearchResult.index);
            if (arrayIndex > -1) {
                if (direction === "up") {
                    if (searchResult[currentSearchPage].length > 0 && searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)].index < currentSearchResult.index) {
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex + 1];
                        // console.log('1', currentSearchResult);
                        await addMark();
                    } else {
                        if (searchResult.length > (currentSearchPage + 1)) {
                            currentSearchPage = currentSearchPage + 1;
                            while (searchResult[currentSearchPage].length === 0) {
                                currentSearchPage = currentSearchPage + 1;
                            }
                            await removeMark();
                            currentSearchResult = searchResult[currentSearchPage][0];
                            // console.log('2', currentSearchResult);
                            await addMark();
                        } else {
                            // console.log("The end up");
                        }
                    }
                } else if (direction === "down") {
                    if (searchResult[currentSearchPage][0].index > currentSearchResult.index) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][arrayIndex - 1];
                        await addMark();
                    } else if (currentSearchPage > 0) {
                        // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                        currentSearchPage = currentSearchPage - 1;
                        while (searchResult[currentSearchPage].length === 0) {
                            currentSearchPage = currentSearchPage - 1;
                        }
                        await removeMark();
                        currentSearchResult = searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)];
                        await addMark();
                    } else {
                        // console.log("The end down");
                    }
                }
            }
        }
    }

    const addMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let re = new RegExp(search.value, "gi"); // search for all instances
            let newText = text.replace(re, `<mark>${text.substr(currentSearchResult.start, search.value.length)}</mark>`);
            element.innerHTML = newText;
            element.parentElement.scrollIntoView();
        }
    }

    const removeMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let newText = text.replace("<mark>", "");
            newText = newText.replace("</mark>", "");
            element.innerHTML = newText;
        }
    }

    const clearSearch = async () => {
        searchResult = [];
        setSearch({ ...search, value: "" });
        document.getElementById("searchInput").value = "";
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ProviderChat")) {
                DemoService.markVisited("ProviderChat");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ProviderChat"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        userApprovalStatus || true ?
            <div id="providerChatDiv" className="providerChatWindow row m-0">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
                <div id="asideLeftContainer" className="col-md-3 col-12 d-flex flex-column">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        <h5 className="mt-2 ml-1">Conversations</h5>
                        {/* <img height="28px" width="auto" src={s1} alt="search" /> */}
                    </div>

                    <ul className="mt-3" id="conversationList">
                        <li key={`conversation0`} className="active">
                            {/* <i className="fas fa-user user mr-3"></i> */}
                            <img className="my-auto" height="32px" width="32px" src={clients[0].profileImage} alt="profileImage" />
                            <div className='ml-3'>{`${clients[0].title} ${clients[0].firstName} ${clients[0].lastName}`}</div>
                            {true ? <i className="fas fa-circle fa-xs ml-3" style={{ color: "#00FF00" }}></i> : null}
                        </li>
                    </ul>
                </div>

                <div id="mainContainer" className="col-md-6 col-12">
                    <div id="header" className="d-flex align-items-center">
                        {
                            search.status ? [
                                <Button key="1" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => { setSearch({ status: false, value: "" }); }}><i className="fas fa-arrow-left"></i></Button>,
                                <InputGroup key="2" className="d-flex my-auto" style={{ width: "100%", marginRight: '15px', border: "1px solid #ced4da", borderRadius: "0.25rem" }}>
                                    <Input id="searchInput" type="text" style={{ border: "none" }} placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
                                    <button className="btn bg-transparent" style={{ color: colors.primary }} onClick={() => clearSearch()}><i className="fa fa-times"></i></button>
                                </InputGroup>,
                                <Button key="3" className="iconButton my-auto" style={{ marginRight: '15px', color: colors.primary }} onClick={() => searchUpDown("up")} ><i className="fas fa-chevron-up"></i></Button>,
                                <Button key="4" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => searchUpDown("down")}><i className="fas fa-chevron-down"></i></Button>
                            ] : [
                                <i
                                    className="fas fa-chevron-left fa-lg back-icon mr-2"
                                    onClick={() => setToggleLeftMenu(true)}
                                ></i>,
                                <i
                                    style={{ fontSize: "2rem", color: "#384E73", cursor: "pointer" }}
                                    className="fas fa-user mr-2"
                                    onClick={() => {
                                        setToggleProfileMenu(!toggleProfileMenu);
                                        setToggleRightMenu(false);
                                    }}
                                ></i>,
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setToggleProfileMenu(!toggleProfileMenu);
                                        setToggleRightMenu(false);
                                    }}
                                >
                                    <h2>{`${clients[0].title} ${clients[0].firstName} ${clients[0].lastName}`}</h2>
                                    <h3>{"online"}</h3>
                                </div>,
                                <div key="3" className="actionBtnContainer iconButton my-auto ml-auto" style={{ color: colors.primary }} onClick={() => setSearch({ status: true, value: "" })}><i className="fas fa-search"></i></div>,
                                <div className="actionBtnContainer">
                                    <div className="actionBtn d-icon">
                                        <i className="fas fa-phone-alt d-icon"></i>
                                    </div>
                                </div>,
                                <div className="actionBtnContainer">
                                    <div className="actionBtn d-icon">
                                        <i className="fas fa-video d-icon"></i>
                                    </div>
                                </div>,
                                <div
                                    className="actionBtnContainer"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setToggleRightMenu(!toggleRightMenu);
                                        setToggleProfileMenu(false);
                                    }}
                                >
                                    <div className="actionBtn d-icon">
                                        <i className="fas fa-edit"></i>
                                    </div>
                                </div>,
                                <input
                                    type="checkbox"
                                    id="nav-toggle"
                                    className="nav-toggle"
                                    onChange={() => setToggleTopMenu(!toggleTopMenu)}
                                ></input>,
                                <label for="nav-toggle" className="ml-auto navbar">
                                    {
                                        toggleTopMenu ?
                                            <i
                                                className="fas fa-times navCls"
                                                style={{ color: "white", zIndex: "300", fontSize: "24px" }}
                                            ></i>
                                            :
                                            <i className="fas fa-bars" style={{ fontSize: "24px" }}></i>
                                    }
                                </label>
                            ]
                        }
                        <nav className={toggleTopMenu ? "" : "d-none"}>
                            <ul>
                                <div className="d-flex flex-row justify-content-between align-items-center menu">
                                    <h5>Menu</h5>
                                </div>

                                <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); setSearch({ status: true, value: "" }); }}>
                                    <div className="actionBtn">
                                        <i className="fas fa-search"></i>
                                    </div>
                                    <li>Search</li>
                                </div>
                                <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); }}>
                                    <div className="actionBtn">
                                        <i className="fas fa-phone-alt my-auto"></i>
                                    </div>
                                    <li>Request a voice call</li>
                                </div>
                                <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); }}>
                                    <div className="actionBtn">
                                        <i className="fas fa-video"></i>
                                    </div>
                                    <li>Request a video call</li>
                                </div>
                                <div
                                    className="d-flex flex-row align-items-center disp"
                                    onClick={() => {
                                        setToggleRightMenu(!toggleRightMenu);
                                        setToggleProfileMenu(false);
                                        setToggleTopMenu(false);
                                    }}
                                >
                                    <div className="actionBtn" style={{ cursor: "pointer" }}>
                                        <i className="fas fa-edit"></i>
                                    </div>
                                    <li>Notes</li>
                                </div>
                            </ul>
                        </nav>
                    </div>
                    <div id="chatDiv" style={{ height: "400px" }}>
                        <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                            {
                                messages.length === 0 ?
                                    <div className="d-flex h-100"><h5 className="m-auto">Seems like the conversation is empty. Send your first message by typing below.</h5></div>
                                    :
                                    messages.map((item, index) => ([
                                        item.isCustomMessage ?
                                            <li key={`message${index}`} data-index={index} style={{ textAlign: 'center' }}>
                                                <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                            </li>
                                            :
                                            item.author === "provider" ?
                                                <li key={`message${index}`} data-index={index} className="me">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>
                                                :
                                                <li key={`message${index}`} data-index={index} className="you">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>
                                    ]))

                            }
                            {
                                isTyping.status && isTyping.identity === "client" ?
                                    <li className="you">
                                        <div className="message typing-indicator">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </li>
                                    : null
                            }
                        </ul>
                        {
                            showChatScrollDown ?
                                <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                    <span><i className="fas fa-angle-double-down"></i></span>
                                </div> : null
                        }
                    </div>
                    <div id="footer" className="d-flex">
                        <div style={{ position: "relative" }}>
                            <Button
                                className="iconButton trigger"
                                style={{ marginRight: "15px" }}
                                onLoad={loadEmojiKeyborad}
                            >
                                <i className="far fa-smile"></i>
                            </Button>
                        </div>
                        <Input
                            style={{ marginRight: "15px", border: "none" }}
                            placeholder="Type your message"
                            value={message}
                            onKeyDown={(e) => handleTyping(e)}
                            onChange={(e) => setMessage(e.target.value)}
                        ></Input>
                        <Button
                            id="sendButton"
                            className="iconButton d-flex flex-row justify-content-center align-items-center"
                            onClick={() => sendMessage()}
                        >
                            <p
                                className="ml-2 mr-3 mt-3"
                                style={{ color: "white", fontSize: "1rem" }}
                            >
                                Send
                            </p>
                            <img height="16px" width="auto" src={send} />
                        </Button>
                    </div>
                </div>

                {/* Notes */}

                <div id="asideRightContainer" className="d-none">
                    <div className="d-flex flex-row align-items-center my-3 pb-2">
                        {toggleRightMenu ? (
                            <h4 className="backBtn mb-0" onClick={() => closeRightMenus()}>
                                <i
                                    className="fas fa-chevron-left"
                                    style={{ color: "#384E73", cursor: "pointer" }}
                                ></i>
                            </h4>
                        ) : null}

                        <img className="ml-2" src={note} height="26px" width="26px" />
                        <h5 className="mb-0 ml-1">Notes</h5>
                    </div>

                    {
                        conversationNotes.map((item, index) => (
                            <p key={index}>
                                <i className="fas fa-circle mr-2" style={{ fontSize: "0.6rem", color: "#48484b" }}></i>
                                {item.content}
                            </p>

                        ))
                    }
                    <p className="mt-3">
                        <Input type="text" placeholder="Type here and click on +" value={newNote.content} onChange={(e) => setNewNote({ messageId: '', content: e.target.value })} />
                    </p>
                    <div className="w-100 text-center">
                        <div className="mx-auto"
                            style={{
                                cursor: "pointer",
                                width: "40px",
                                height: "40px",
                                fontSize: "2rem",
                                borderRadius: "50%",
                                background: colors.primary,
                                lineHeight: "34px",
                                color: "white"
                            }}
                            onClick={addNote}
                        >+</div>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center my-auto tip">
                        <i className="fas fa-lightbulb"> Tip</i>
                        <p className="mt-1 text-center">
                            Double press on message to add it<br />to the notes
                        </p>
                    </div>
                </div>

                {/* CLient Profile */}
                <div id="asideProfileContainer" className="d-none">
                    <div className="d-flex flex-row mt-3 align-items-center">
                        {toggleProfileMenu ? (
                            <h4 className="backBtn" onClick={() => closeRightMenus()}>
                                <i
                                    className="fas fa-chevron-left mx-2"
                                    style={{ cursor: "pointer" }}
                                ></i>
                            </h4>
                        ) : null}
                        <h5 className="ml-2">Client Profile</h5>
                    </div>
                    <div className="my-4 mx-auto">
                        <i
                            style={{ fontSize: "3rem", margin: "1rem" }}
                            className="fas fa-user icon"
                        ></i>
                    </div>
                    <div className="ml-2 d-flex align-items-center">
                        <i
                            className="fas fa-user icon mr-3"
                            style={{ fontSize: "1.4rem" }}
                        ></i>
                        <div>
                            <h6 className="mb-0">Name</h6>
                            {`${clients[0].title} ${clients[0].firstName} ${clients[0].lastName}`}
                        </div>
                    </div>
                    <div className="mt-2 ml-2 d-flex align-items-center">
                        <i
                            className="fas fa-map-marker-alt icon mr-3"
                            style={{ fontSize: "1.4rem" }}
                        ></i>
                        <div>
                            <h6 className="mb-0">Location and Time</h6>
                            {`${clients[0].city}, ${clients[0].state} ${clients[0].country}`}
                            {/* Surat, Gujarat, India | 12:00 PM */}
                        </div>
                    </div>

                    {/* Other details */}
                    <div className="mt-4 ml-2" >
                        <button
                            type="button"
                            onClick={toggle}
                            className="pd-1 d-flex align-items-center justify-content-between px-0 m-display"
                        >
                            Other Details
                            {isOpen ? (
                                <i
                                    className="fas fa-angle-up
         icon"
                                    style={{ fontSize: "1.4rem" }}
                                ></i>
                            ) : (
                                <i
                                    className="fas fa-angle-right
         icon"
                                    style={{ fontSize: "1.4rem", color: "#232325" }}
                                ></i>
                            )}
                        </button>

                        <Collapse isOpen={isOpen}>
                            <div className="mt-3 ml-1 d-flex align-items-center">
                                <i
                                    className="fas fa-envelope icon mr-3"
                                    style={{ fontSize: "1.3rem" }}
                                ></i>
                                <div>
                                    <h6 className="mb-0">Email</h6>
                                    {clients[0].email}
                                    {/* joe@gmail.com */}
                                </div>
                            </div>

                            <div className="mt-3 ml-1 d-flex align-items-center">
                                <i
                                    className="fas fa-phone-alt icon mr-3"
                                    style={{ fontSize: "1.3rem" }}
                                ></i>
                                <div>
                                    <h6 className="mb-0">Mobile no</h6>
                                    {clients[0].phone}
                                    {/* 9876543210 */}
                                </div>
                            </div>

                            <div className="mt-3 ml-1 d-flex align-items-center">
                                <i
                                    className="fas fa-tag fa-flip-horizontal icon mr-3"
                                    style={{ fontSize: "1.3rem" }}
                                ></i>
                                <div>
                                    <h6 className="mb-0">Subscription plan</h6>
                                    {clientSubscriptionPlans[1].name}
                                    {/* Starter Pack */}
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div >
            :
            <UserNotApproved />
    )
}

export default ProviderChat;